var _defs, _path, _g, _g2, _g3, _g4, _path2, _rect, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _polygon, _polygon2, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 788.07 225.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#1c1a16;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:url(#linear-gradient);}.cls-5{clip-path:url(#clip-path-2);}.cls-6{fill:url(#linear-gradient-2);}.cls-7{clip-path:url(#clip-path-3);}.cls-8{fill:url(#linear-gradient-3);}.cls-9{clip-path:url(#clip-path-4);}.cls-10{fill:url(#linear-gradient-4);}.cls-11{fill:#fbfbfb;}.cls-12{fill:#fcfcfd;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.6,48.9V189.74A3.1,3.1,0,0,0,88.51,193l75-74.34L89.13,44.89c-1.49.42-2.53,1.77-2.53,4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -857.87,
    y1: 2986.01,
    x2: -856.87,
    y2: 2986.01,
    gradientTransform: "matrix(0, 152.48, 152.48, 0, -455177.98, 130849.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2079b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#4a98b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#81bfbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97cfbf"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.13,44.89l74.36,73.73,20.65-20.48-31-17.92-.16-.09h0l-.08,0h0l-.07,0h0l0,0h-.08L93.06,45.55a6,6,0,0,0-2.86-.8,4.18,4.18,0,0,0-1.07.14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -840.29,
    y1: 3003.11,
    x2: -839.29,
    y2: 3003.11,
    gradientTransform: "matrix(97.54, 0, 0, -97.54, 82049.18, 293008.34)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5abcab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e99a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.51,193a4,4,0,0,0,3.21-.5l8.68-5L153.1,157l15.52-9,15.52-9-20.65-20.47Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -870.57,
    y1: 2988.99,
    x2: -869.57,
    y2: 2988.99,
    gradientTransform: "matrix(0, 76.79, 76.79, 0, -229397.17, 66972.07)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e53432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#d43745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#a33e7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#904192"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M163.49,118.62l20.65,20.47,22.7-13.1,7.14-4.12c3.38-2,3.18-4.61.49-6.23l-.19-.1-.09-.06c-2.76-1.48-26.61-15.34-29.71-17.15l-.34-.19Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -892.94,
    y1: 2994.18,
    x2: -891.94,
    y2: 2994.18,
    gradientTransform: "matrix(0, 40.96, 40.96, 0, -122436.61, 36668.56)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f18779"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#f9b574"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdcb72"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M788.18,202.76a22.38,22.38,0,0,1-22.63,22.41H22.09A21.69,21.69,0,0,1,0,203.05v-181A21.65,21.65,0,0,1,22.09,0H765.55c12.55,0,22.52,9.54,22.52,22.08v181Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 86.6,
    y: 44.89,
    width: 76.89,
    height: 148.08
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 89.13,
    y: 44.75,
    width: 95.01,
    height: 73.87
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 88.51,
    y: 118.62,
    width: 95.63,
    height: 74.64
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 163.49,
    y: 98.14,
    width: 53.87,
    height: 40.96
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M570.67,148.42a19.24,19.24,0,0,1-7.91-1.59,14.93,14.93,0,0,1-6-4.92h-.49a58.38,58.38,0,0,1,.49,7.36v18.25H550V103.27h5.46l.92,6.07h.33a15.64,15.64,0,0,1,6-5.26,18.29,18.29,0,0,1,7.89-1.62q8.82,0,13.61,6t4.8,16.91q0,10.92-4.87,17t-13.54,6m-1-40.25q-6.81,0-9.83,3.76t-3.12,12v1.49q0,9.34,3.12,13.38t10,4a10.39,10.39,0,0,0,9-4.65q3.25-4.65,3.26-12.83t-3.26-12.72a10.7,10.7,0,0,0-9.16-4.43"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 597.91,
    y: 84.66,
    width: 6.71,
    height: 62.96
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M643.24,147.61l-1.33-6.31h-.33A18.77,18.77,0,0,1,635,147a20.29,20.29,0,0,1-8.24,1.47q-6.59,0-10.33-3.39t-3.75-9.67q0-13.44,21.49-14.08l7.52-.25v-2.75c0-3.48-.74-6-2.24-7.71s-3.9-2.48-7.18-2.48q-5.55,0-12.55,3.39l-2.06-5.13a31.83,31.83,0,0,1,7.18-2.8,31.27,31.27,0,0,1,7.83-1c5.29,0,9.2,1.17,11.76,3.52s3.82,6.11,3.82,11.29v30.26Zm-15.17-4.73q6.27,0,9.85-3.44t3.58-9.63v-4l-6.72.28q-8,.28-11.55,2.49a7.51,7.51,0,0,0-3.54,6.86A6.93,6.93,0,0,0,621.9,141a9.13,9.13,0,0,0,6.17,1.9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M652.12,103.27h7.2L669,128.56a97.8,97.8,0,0,1,4,12.5h.32c.35-1.38,1.09-3.73,2.2-7.06s4.78-13.57,11-30.73h7.2l-19.06,50.49q-2.83,7.49-6.62,10.63a14,14,0,0,1-9.28,3.13,27,27,0,0,1-6.07-.69v-5.38a23,23,0,0,0,5,.49q6.92,0,9.87-7.77l2.47-6.31Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M446.25,107.39c2.13,1.76,6.58,5.47,6.58,12.52,0,6.86-3.89,10.12-7.79,13.17-1.21,1.21-2.59,2.51-2.59,4.55s1.38,3.15,2.41,4l3.34,2.59c4.08,3.43,7.79,6.59,7.79,13,0,8.72-8.44,17.53-24.39,17.53-13.45,0-19.94-6.4-19.94-13.27,0-3.34,1.66-8.06,7.14-11.32,5.74-3.52,13.54-4,17.71-4.26-1.3-1.67-2.78-3.43-2.78-6.3a8.21,8.21,0,0,1,.93-3.62c-1,.09-2.05.18-3,.18-9.82,0-15.39-7.33-15.39-14.56a16.67,16.67,0,0,1,5.94-12.43c5.28-4.36,11.59-5.1,16.6-5.1h19.1L452,107.39Zm-6.59,41.18a15.42,15.42,0,0,0-2.13-.09,37.16,37.16,0,0,0-9.74,1.49c-2,.73-8,3-8,9.55s6.4,11.32,16.32,11.32c8.9,0,13.64-4.28,13.64-10,0-4.74-3.06-7.24-10.12-12.25m2.7-17.62c2.13-2.14,2.31-5.1,2.31-6.77,0-6.68-4-17.07-11.68-17.07a8.7,8.7,0,0,0-6.5,3.06,10.75,10.75,0,0,0-2,6.87c0,6.21,3.62,16.51,11.6,16.51a9.53,9.53,0,0,0,6.31-2.6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M387.86,147.09c-14.72,0-22.59-11.48-22.59-21.86,0-12.13,9.9-22.49,24-22.49a21.65,21.65,0,0,1,22.13,21.85c0,10.92-8.42,22.5-23.52,22.5m11.57-7.5c2.23-3,2.79-6.67,2.79-10.28,0-8.15-3.89-23.71-15.38-23.71a12.93,12.93,0,0,0-8.33,3.15c-3.61,3.24-4.26,7.32-4.26,11.3,0,9.16,4.54,24.25,15.74,24.25a11.82,11.82,0,0,0,9.44-4.71"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M337.67,147.09c-14.72,0-22.6-11.48-22.6-21.86,0-12.13,9.92-22.49,24-22.49a21.65,21.65,0,0,1,22.13,21.85c0,10.92-8.42,22.5-23.52,22.5m11.58-7.5c2.22-3,2.77-6.67,2.77-10.28,0-8.15-3.89-23.71-15.37-23.71a12.93,12.93,0,0,0-8.33,3.15c-3.61,3.24-4.26,7.32-4.26,11.3,0,9.16,4.53,24.25,15.74,24.25a11.84,11.84,0,0,0,9.45-4.71"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M308,145.64l-13.31,3.07a98.86,98.86,0,0,1-15.36,1.58c-25.7,0-35.48-18.9-35.48-33.7,0-18.06,13.88-34.82,37.62-34.82a53.71,53.71,0,0,1,14.24,2A36.22,36.22,0,0,1,308,89.5l-7.73,7.35L297,97.6l2.33-3.73c-3.16-3.07-8.94-8.75-19.92-8.75-14.71,0-25.79,11.18-25.79,27.47,0,17.5,12.66,34,32.95,34a27.74,27.74,0,0,0,11.83-2.33v-15l-14.06.74,7.45-4h19.73l-2.41,2.32a2.21,2.21,0,0,0-.94,1.49c-.09.84-.18,3.55-.18,4.47Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M475.68,143c-3.08-.28-3.72-.84-3.72-4.48V85.79c0-.2,0-.4.05-.6.38-3.25,1.31-3.81,4.2-5.49H462.89l-7,3.35H463v57.49c0,1.85-.36,2.14-2.51,4.93H477l3.45-2c-1.58-.2-3.17-.29-4.75-.47"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M513.56,143.81c-1,.56-2,1.21-3,1.67a21.65,21.65,0,0,1-9,1.75,19.79,19.79,0,0,1-12.3-3.6c-6.56-4.63-9.42-12.58-9.42-19.51,0-14.33,11.64-21.36,21.17-21.36a18,18,0,0,1,9.53,2.59A15.33,15.33,0,0,1,517,114.5l-21.72,8.79-7.12.55c2.3,11.74,10.26,18.58,19,18.58,4.72,0,8.14-1.66,11.28-3.23Zm-8.69-27.55c1.76-.65,2.68-1.21,2.68-2.5,0-3.69-4.16-8-9.15-8-3.71,0-10.64,2.87-10.64,12.85,0,1.57.19,3.24.29,4.91Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "522.49 103.39 522.49 109.5 521.74 109.5 521.74 103.39 519.73 103.39 519.73 102.76 524.5 102.76 524.5 103.39 522.49 103.39"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "530.8 109.5 530.8 103.34 530.77 103.34 528.89 109.5 528.31 109.5 526.41 103.34 526.39 103.34 526.39 109.5 525.72 109.5 525.72 102.76 526.87 102.76 528.59 108.2 528.61 108.2 530.3 102.76 531.47 102.76 531.47 109.5 530.8 109.5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M262.35,63.64h-4.63a30.64,30.64,0,0,0-1.32-5.4h-6.68a28.52,28.52,0,0,0-1.36,5.4H244q0-.55,3.37-9.25t3.38-9.57h5.46q0,.82,3.06,9.43t3.06,9.39m-6.68-8.16a83.43,83.43,0,0,1-2.48-8.07H253a84.14,84.14,0,0,1-2.56,8.07Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M281,63.64h-3.57q0-.59-4-6.26c-2.77-4-4.36-6.7-4.74-8.16h-.23a51.1,51.1,0,0,1,.36,5.72q0,3.57.2,8.7h-3.56q.22-4.47.22-9.84t-.22-9h4.3q0,.76,3.57,6.12,3.8,5.67,4.36,7.7h.22a54.84,54.84,0,0,1-.34-5.78q0-3.91-.21-8H281c-.14,2.39-.21,5.39-.21,9s.07,6.9.21,9.84"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M301.94,53.58a10.67,10.67,0,0,1-2.63,7.17,9.18,9.18,0,0,1-7.37,3.07q-2.15,0-5.9-.18c.12-2.91.19-6.19.19-9.84s-.07-6.5-.19-9h2.53c.41,0,1,0,1.85,0l1.6-.05q5.22,0,7.57,2.61a9,9,0,0,1,2.35,6.24m-3.95.63a6.94,6.94,0,0,0-1.62-4.68,6.12,6.12,0,0,0-4.94-1.9,14.53,14.53,0,0,0-1.71.13c.1,1.92.15,3.94.15,6,0,2.3.05,4.59.14,6.85a9.23,9.23,0,0,0,1.88.19,5.47,5.47,0,0,0,4.61-1.93,7.5,7.5,0,0,0,1.49-4.7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M321.26,63.64H317a28.85,28.85,0,0,0-2.57-6.31,3.37,3.37,0,0,0-2.89-1.2h-1.61c0,2.48,0,5,.13,7.5h-4q.19-4.37.19-9.84,0-5.26-.19-9h2.5l1.82,0c.92,0,1.77-.05,2.55-.05q6.63,0,6.63,4.55c0,2.39-1.26,4.07-3.78,5v.22a4.56,4.56,0,0,1,2.56,2.27,50.6,50.6,0,0,1,3,6.86m-5.42-13.3q0-2.87-3.7-2.87a13.05,13.05,0,0,0-2.4.2c.1,1.49.16,3.44.16,5.84l1.34,0q4.61,0,4.6-3.2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M342,53.89a10.33,10.33,0,0,1-2.72,7.35,8.8,8.8,0,0,1-6.72,2.92,8.5,8.5,0,0,1-6.39-2.68,9.45,9.45,0,0,1-2.57-6.81,10.34,10.34,0,0,1,2.72-7.36A8.8,8.8,0,0,1,333,44.39a8.53,8.53,0,0,1,6.39,2.67A9.48,9.48,0,0,1,342,53.89m-4,.41a7.49,7.49,0,0,0-1.54-4.9,4.79,4.79,0,0,0-3.82-1.88,4.41,4.41,0,0,0-3.59,1.9,7.58,7.58,0,0,0-1.47,4.79,7.48,7.48,0,0,0,1.55,4.89A4.79,4.79,0,0,0,332.93,61a4.4,4.4,0,0,0,3.59-1.9A7.59,7.59,0,0,0,338,54.3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M350.16,63.64h-4.09c.12-3,.19-6.26.19-9.84s-.07-6.51-.19-9h4.09q-.2,3.65-.19,9t.19,9.84"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M371.11,53.58a10.67,10.67,0,0,1-2.63,7.17,9.17,9.17,0,0,1-7.37,3.07q-2.14,0-5.9-.18c.12-2.91.19-6.19.19-9.84s-.07-6.5-.19-9h2.53c.41,0,1,0,1.85,0l1.6-.05q5.22,0,7.57,2.61a9,9,0,0,1,2.35,6.24m-3.95.63a6.89,6.89,0,0,0-1.62-4.68,6.1,6.1,0,0,0-4.94-1.9,14.39,14.39,0,0,0-1.7.13c.09,1.92.14,3.94.14,6,0,2.3,0,4.59.15,6.85a9.13,9.13,0,0,0,1.87.19,5.46,5.46,0,0,0,4.61-1.93,7.44,7.44,0,0,0,1.49-4.7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M398.91,63.64h-4.63a31.18,31.18,0,0,0-1.31-5.4h-6.68a27.69,27.69,0,0,0-1.36,5.4h-4.35q0-.55,3.37-9.25t3.38-9.57h5.46q0,.82,3.06,9.43t3.06,9.39m-6.68-8.16a81.43,81.43,0,0,1-2.47-8.07h-.24c0,.38-.85,3.06-2.55,8.07Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M415.77,49.75a5.65,5.65,0,0,1-2.56,5.11,11.49,11.49,0,0,1-6.3,1.64c-.45,0-.78,0-1,0q0,2.73.16,7.17H402c.12-2.78.19-6.06.19-9.84,0-3.47-.07-6.46-.19-9h2.51c.36,0,1,0,2.06,0s1.89-.05,2.63-.05A8.26,8.26,0,0,1,413.88,46a4.2,4.2,0,0,1,1.89,3.77m-3.73.8q0-3.11-4.1-3.1a11.17,11.17,0,0,0-2.17.22c.1,1.82.16,3.88.16,6.19.24,0,.52,0,.83,0,3.52,0,5.28-1.12,5.28-3.34"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M433.11,49.75a5.67,5.67,0,0,1-2.56,5.11,11.51,11.51,0,0,1-6.3,1.64c-.45,0-.78,0-1,0q0,2.73.16,7.17h-4.06c.12-2.78.19-6.06.19-9.84,0-3.47-.07-6.46-.19-9h2.51c.36,0,1,0,2.05,0s1.89-.05,2.64-.05A8.28,8.28,0,0,1,431.22,46a4.2,4.2,0,0,1,1.89,3.77m-3.73.8q0-3.11-4.11-3.1a11.15,11.15,0,0,0-2.16.22c.1,1.82.16,3.88.16,6.19.24,0,.52,0,.83,0,3.52,0,5.28-1.12,5.28-3.34"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M461.46,53.89a10.37,10.37,0,0,1-2.72,7.35A8.8,8.8,0,0,1,452,64.16a8.47,8.47,0,0,1-6.39-2.68,9.41,9.41,0,0,1-2.57-6.81,10.37,10.37,0,0,1,2.71-7.36,8.83,8.83,0,0,1,6.73-2.92,8.53,8.53,0,0,1,6.39,2.67,9.48,9.48,0,0,1,2.57,6.83m-4,.41a7.49,7.49,0,0,0-1.55-4.9,4.76,4.76,0,0,0-3.81-1.88,4.4,4.4,0,0,0-3.59,1.9,7.58,7.58,0,0,0-1.47,4.79,7.43,7.43,0,0,0,1.55,4.89A4.79,4.79,0,0,0,452.41,61a4.38,4.38,0,0,0,3.58-1.9,7.53,7.53,0,0,0,1.48-4.78"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M481.05,63.64h-3.57q0-.59-4-6.26-4.17-6-4.74-8.16h-.24a51.29,51.29,0,0,1,.37,5.72c0,2.38.06,5.28.2,8.7h-3.56q.22-4.47.22-9.84t-.22-9h4.29c0,.51,1.2,2.55,3.58,6.12q3.79,5.67,4.36,7.7H478a55.07,55.07,0,0,1-.35-5.78c0-2.61-.06-5.29-.2-8h3.61c-.13,2.39-.2,5.39-.2,9s.07,6.9.2,9.84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.cc4388021382d1740d21eadc8e09c9dc.svg";
export { ForwardRef as ReactComponent };